import { Component, HostBinding, Input } from '@angular/core';
import { KpiPercentage } from '../../models/report.model';

@Component({
    selector: 'app-custom-kpi-bar',
    templateUrl: './custom-kpi-bar.component.html',
    styleUrl: './custom-kpi-bar.component.scss',
})
export class CustomKpiBarComponent {
    uploadedChartData = [{ value: 36 }];
    @Input() kpiData: KpiPercentage[];
    hideMinMaxBars = (point: any) => {
        if (point?.data?.name === 'min' || point?.data?.name === 'max') {
            return { visible: false };
        }

        return { visible: true };
    };
    customizeYAxisLabel = (arg: any) => {
        return `${arg.value}%`;
    };

    adaptiveLayout = {
        width: 120, // px → triggers adaptive mode
        // height: 160,
    };
}
